export enum LoanType {
  Retail = 1,
  Lease = 2,
  Cash = 4,
  Balloon = 8,
  All = 15
}

export const LoanTypeNames = new Map<number, string>([
  [LoanType.Retail, 'Retail'],
  [LoanType.Lease, 'Lease'],
  [LoanType.Cash, 'Cash'],
  [LoanType.Balloon, 'Balloon'],
  [LoanType.All, 'All']
]);

export const LoanTypeIds = new Map<string, number>([
  ['Retail', LoanType.Retail],
  ['Lease', LoanType.Lease],
  ['Cash', LoanType.Cash],
  ['Balloon', LoanType.Balloon],
  ['All', LoanType.All]
]);

export enum LeaseRateType {
  Rate = 1,
  Factor = 2
}

export type DynamicWorkSheetColumn = 0 | 1 | 2 | 3
export type CheckColumnsPaymentsConfig = {
  retailColumns: DynamicWorkSheetColumn[],
  leaseColumns: DynamicWorkSheetColumn[]
}

export const DynamicWorkSheetConfigOption: Record<string, DynamicWorkSheetColumn> = {
  RetailDefaultDownPaymentOption1: 0,
  RetailDefaultDownPaymentOption2: 1,
  RetailDefaultDownPaymentOption3: 2,
  RetailDefaultDownPaymentOption4: 3,
  LeaseDefaultDownPaymentOption1: 0,
  LeaseDefaultDownPaymentOption2: 1,
  LeaseDefaultDownPaymentOption3: 2,
  LeaseDefaultDownPaymentOption4: 3,
}